import React from 'react'
import { Helmet } from 'react-helmet'
import { 
  Navbar, Footer, Landing, About, Skills, Testimonials, Blog, 
  Education, Experience, Contacts, Projects, Services, Achievement 
} from '../../components'
import GithubStat from '../../components/GitHubStat/GithubStat' // Direct import// Direct import

function Main() {
    return (
        <div>
            <Helmet>
                <title>Muhammad Abdullah</title>
            </Helmet>

            <Navbar />        
            <Landing />
            <About />
            <Education />
            <Skills />
            <Experience />
            <Projects />
            <Achievement />
            <GithubStat /> {/* Add GitHub Statistics Section */}
            <Services />
            <Testimonials />
            <Blog />
            <Contacts />
            <Footer />
        </div>
    )
}

export default Main